import { ConfigService } from '@services/webFeeder/config.service';
import { environment } from 'src/environments/environment';
import { Component, OnInit, HostListener } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AutoLogoutService } from '@auth/auto-logout-service.service';
import { Constants } from '@utils/constants';
import { WhitelabelEnum } from '@model/enum/whitelabel.enum';

@Component({
  selector: 'app-manual-online',
  templateUrl: './manual-online.component.html'
})
export class ManualOnlineComponent implements OnInit {

  loading = true;
  title = Constants.TITLE_CARD_MANUAL;
  broker = environment.BROKER_PATH;
  wlConfig = this._configService.getConfigWhitelabel();
  isRanking: boolean;
  isMultibroker: boolean;
  showFormLogin: boolean;
  showDoubleAuthAfc: boolean;
  showDoubleAuthEletronicSignature: boolean;
  showChangeEletronicSignature: boolean;
  showChangePassword: boolean;
  isLoggedNegotiation: boolean;
  maxCardItemWks = Constants.NUM_MAX_WORKSPACE_CARDS;
  showSuitability: boolean;
  isAssessor: boolean;
  showPositionEarnings: boolean;
  showPositionBMF: boolean;
  showSideBarBrokerageNote: boolean;
  showSideBarExtract: boolean;
  showSideBarMenuDeposit: boolean;
  showUrlStore = this._configService.registerGoToIdentity() && this.wlConfig.system.cod === WhitelabelEnum.CEDRO;

  @HostListener('mousemove')
  onMouseMove() {
    this._autoLogoutService.resetTime();
  }

  @HostListener('click')
  onClick() {
    this._autoLogoutService.resetTime();
  }

  constructor(
    public _dialogRef: MatDialogRef<ManualOnlineComponent>,
    private _autoLogoutService: AutoLogoutService,
    private _configService: ConfigService
  ) {
    this.getConfigWhitelabel();
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }

  getConfigWhitelabel() {
    this.isRanking = this.wlConfig.system.cod === WhitelabelEnum.RANKING ? true : false;
    this.isMultibroker = this.wlConfig.system.isMultiBroker;
    this.showFormLogin = this.wlConfig.system.login_type === Constants.LOGIN_TYPE.LoginS || this.wlConfig.system.login_type === Constants.LOGIN_TYPE.LoginO ? true : false;
    this.showDoubleAuthAfc = this.wlConfig.system.login_type === Constants.LOGIN_TYPE.LoginO ? true : false;
    this.showDoubleAuthEletronicSignature = this._configService.getEletronicSignatureType() && this._configService.getEletronicSignatureType().isActive ? true : false;
    this.showChangeEletronicSignature = this.showDoubleAuthEletronicSignature && this.wlConfig.system.login_type === Constants.LOGIN_TYPE.LoginW;
    this.showChangePassword = this.wlConfig.system.login_type === Constants.LOGIN_TYPE.LoginS || this.wlConfig.password.isActive ? true : false;
    this.showSuitability = this.wlConfig.sidebar.showProfileSuitabilityName;
    this.isAssessor = this._configService.isUserAssessorLogged();
    this.showPositionEarnings = this.wlConfig.custody.showPositionEarnings;
    this.showPositionBMF = this.wlConfig.custody.showPositionBMF;
    this.showSideBarBrokerageNote = this.wlConfig.sidebar.showSideBarBrokerageNote;
    this.showSideBarExtract = this.wlConfig.sidebar.showSideBarExtract;
    this.showSideBarMenuDeposit = this.wlConfig.sidebar.showSideBarMenuDeposit;
  }

  ngOnInit() {
    this._configService.authHbLogged$.subscribe(loggedNegotiation => {
      this.isLoggedNegotiation = loggedNegotiation;
    });
  }

  close() {
    this._dialogRef.close();
  }

  scrollTopInit() {
    const mainDiv = document.getElementById('scrollable-area');
    if (mainDiv && mainDiv.scrollTop && mainDiv.scrollTop > 0) {
      mainDiv.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  scrollTop() {
    const mainDiv = document.getElementById('scrollable-area');
    mainDiv.scrollTo({ top: 0, behavior: 'smooth' });
  }

  onScroll(event) {
    if (event.target.scrollTop > 0) {
      document.getElementById('btn-scroll').classList.remove('btn-hidden');
    } else {
      document.getElementById('btn-scroll').classList.add('btn-hidden');
    }
  }

  goToLink(value) {
    const element = document.querySelector(value);
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

}
